import { API_URL } from './config'
import token from './Token'

const authenticatedUrl = (path) => `${API_URL}${path}${path.includes('?') ? '&' : '?'}token=${encodeURIComponent(token || '')}`

const readResponse = async (response) => {
    let payload = null
    try {
        payload = await response.json()
    } catch (error) {
        payload = null
    }
    if (!response.ok || payload?.error) {
        throw new Error(payload?.error || 'The Goals service request failed.')
    }
    return payload
}

const postForm = async (path, values) => {
    const body = new URLSearchParams()
    Object.entries(values).forEach(([key, value]) => body.append(key, value))
    const response = await fetch(authenticatedUrl(path), {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
    })
    return readResponse(response)
}

export const fetchGoals = async (includeProgress = false) => {
    const response = await fetch(authenticatedUrl(`/goals?includeProgress=${includeProgress ? 'true' : 'false'}`))
    const payload = await readResponse(response)
    return Array.isArray(payload) ? payload : []
}

export const fetchGoalTriggerOptions = async () => {
    const response = await fetch(authenticatedUrl('/goalTriggerOptions'))
    const payload = await readResponse(response)
    return Array.isArray(payload) ? payload : []
}

export const saveGoal = (goal) => postForm('/saveGoal', { data: JSON.stringify(goal) })

export const deleteGoal = (goalId) => postForm('/deleteGoal', { id: goalId })

export const recordGoalAttempts = (session) => postForm('/recordGoalAttempts', { data: JSON.stringify(session) })

export const saveGoalAnswers = (completionId, answersByGoal) => postForm('/saveGoalAnswers', {
    data: JSON.stringify({ completionId, answersByGoal }),
})
